import { render, staticRenderFns } from "./TheAppSwitcherItem.vue?vue&type=template&id=51bf9663"
import script from "./TheAppSwitcherItem.vue?vue&type=script&lang=js"
export * from "./TheAppSwitcherItem.vue?vue&type=script&lang=js"
import style0 from "./TheAppSwitcherItem.vue?vue&type=style&index=0&id=51bf9663&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports